import { notEmpty } from '@festina-life/core'
import { Alert, Tooltip } from '@festina-life/ui/feedback'
import { useTranslate } from '@festina-life/ui/hooks'
import { useEffect } from 'react'

import { useHook } from '../../lenteHooks'
import { withLifeErrorBoundary } from '../../libs/withLifeErrorBoundary'
import type { StopAlertsProps } from '../participantOverview/participant/types'
import { MoneyOutStopReasons } from './MoneyOutStopReasons'

const MoneyOutStopAlertInternal = ({
  onHandleResourcesInStop,
}: StopAlertsProps) => {
  const translate = useTranslate()

  const { tenantId, legalEntityId } = useHook(
    'routing.general.useLegalEntityParams',
  )()
  const { data: payableStopCollection } = useHook(
    'fetchers.moneyOut.useFetchPayableStops',
  )({
    tenantId,
    receiverId: legalEntityId,
  })

  const payableStops =
    payableStopCollection?.payableStops?.filter(notEmpty) ?? []

  const isInStop = (payableStops?.length ?? 0) > 0

  useEffect(() => {
    onHandleResourcesInStop((x) => ({ ...x, moneyOut: isInStop }))
  }, [isInStop, onHandleResourcesInStop])

  return (
    isInStop && (
      <Tooltip tip={<MoneyOutStopReasons payableStops={payableStops} />}>
        <Alert severity="warning">
          {`${translate('component.moneyout')}: ${translate('status.stopped')}`}
        </Alert>
      </Tooltip>
    )
  )
}

export const MoneyOutStopAlert = withLifeErrorBoundary(
  MoneyOutStopAlertInternal,
)
